import React, { useEffect, useRef, useState } from 'react'
import { Button, Form } from 'react-bootstrap'

import { api_gateway } from '../../../conexoes/api'
import { setaDropdown } from '../../../utils/alternanciaIcones'
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js'

export default function SelectNivelImportancia(props) {
  const [spinAtivo, setSpinAtivo] = useState(true)
  const [lsNivelImportancia, setLsNivelImportancia] = useState()
  const modal = useRef()

  const handleClickFora = (e) => {
    if (!modal.current.contains(e.target)) {
      handleCancelar()
    }
  }

  function handleNivelImportancia(cdNivelImportancia) {
    props.setCdNivelImportancia(cdNivelImportancia)
    handleCancelar()
  }

  function handleCancelar() {
    props.setRevelarSelectNivelImportancia(false)
  }

  useEffect(() => {
    setSpinAtivo(true)
    async function renderNivelImportancia() {
      const { data } = await api_gateway.get('/m1/consultar/aut_regra_nivel')
      if (data.dados.length > 0) {
        let objetoNivelImportancia = data.dados.map((item, i) => {
          return (
            <li key={'menu-' + item.cd_aut_regra_nivel}>
              <div
                className="campo-select-opcao campo-select-opcao-2 campo-select-opcao-automacao"
                onClick={() => handleNivelImportancia(item.cd_aut_regra_nivel)}
              >
                {item.cd_aut_regra_nivel === 3 && (
                  <div className="item-select-nivel-importancia-container-esfera">
                    <div className="item-select-nivel-importancia-esfera-verde" />
                    <p className="fonte-cor-1 nao-selecionavel">
                      {item.ds_aut_regra_nivel}
                    </p>
                  </div>
                )}
                {item.cd_aut_regra_nivel === 2 && (
                  <div className="item-select-nivel-importancia-container-esfera">
                    <div className="item-select-nivel-importancia-esfera-amarela" />
                    <p className="fonte-cor-1 nao-selecionavel">
                      {item.ds_aut_regra_nivel}
                    </p>
                  </div>
                )}
                {item.cd_aut_regra_nivel === 1 && (
                  <div className="item-select-nivel-importancia-container-esfera">
                    <div className="item-select-nivel-importancia-esfera-vermelha" />
                    <p className="fonte-cor-1 nao-selecionavel">
                      {item.ds_aut_regra_nivel}
                    </p>
                  </div>
                )}
              </div>
              {data.dados[i + 1] !== undefined && (
                <div className="campo-select-divisor-cor-1 campo-select-divisor" />
              )}
            </li>
          )
        })
        setLsNivelImportancia(objetoNivelImportancia)
      } else {
        let objetoNivelImportancia = () => {
          return (
            <li>
              <div disabled className="campo-select-opcao campo-select-opcao-1">
                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">
                  Nenhuma informação encontrada
                </span>
              </div>
            </li>
          )
        }
        setLsNivelImportancia(objetoNivelImportancia)
      }
      setSpinAtivo(false)
    }
    renderNivelImportancia()
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Form ref={modal}>
      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      <Button
        name="cdTipoPessoa"
        className="campo-texto-cor-3 campo-select"
        onClick={() => props.setRevelarSelectNivelImportancia(false)}
      >
        <div className="fonte-cor-1 label-campo">
          {props.dsNivelImportancia}
        </div>
        <img
          className="campo-select-icone-ativado"
          src={setaDropdown()}
          alt="drop"
        />
      </Button>
      <div className="campo-select-triangulo-cor-1 campo-select-triangulo-position-fixed" />
      <div className="campo-texto-cor-3 campo-select-corpo-position-fixed width-250px">
        <ul className="campo-select-lista">{lsNivelImportancia}</ul>
      </div>
    </Form>
  )
}
